import React from 'react';

import { useGetUser } from '@/api';
import { Loading } from '@components/ui-components';

interface UserWrapperProps {
  children: React.ReactNode;
}

const UserWrapper: React.FC<UserWrapperProps> = ({ children }) => {
  const { data, isLoading } = useGetUser();
  const shouldRenderChildren = Boolean(data?.user);

  if (isLoading) {
    return <Loading position='absoluteCenter' />;
  }

  return <>{shouldRenderChildren && children}</>;
};

export default UserWrapper;
